<template>
  <a-card :bordered="false">
    <div class="title">{{ info.branch_name }}设备{{ info.no }}</div>
    <s-table size="default" :columns="columns" :data="loadData"> </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getEquipmentData, getEquipmentInfo } from "@/api/setting/equipment";
import { encodeJsonToQuery } from "@/utils/util";
import { ACCESS_TOKEN } from "@/store/mutation-types";

export default {
  name: "EquipmentReadings",
  components: {
    STable,
  },
  data() {
    return {
      info: {},
      columns: [
        {
          title: "日期",
          dataIndex: "created",
        },
        {
          title: "投币数",
          dataIndex: "coin",
        },
        {
          title: "出彩数",
          dataIndex: "hit",
        },
        {
          title: "累计投币数",
          dataIndex: "coin_total",
        },
        {
          title: "累计出彩数",
          dataIndex: "hit_total",
        },
      ],
      loadData: (params) => {
        return getEquipmentData({ ...params, id: this.$route.params.id }).then(
          (res) => res
        );
      },
    };
  },
  created() {
    // this.getBranchList();
    this.handleGetEquipmentInfo();
  },
  // created() {
  //   this.handleGetEquipmentInfo();
  // },
  methods: {
    handleGetEquipmentInfo: function () {
      getEquipmentInfo(this.$route.params.id).then((res) => {
        console.log(res);
        this.info = res;
      });
    },
    handleExport: function () {
      const params = {
        id: this.$route.params.id,
        token: this.$ls.get(ACCESS_TOKEN),
      };
      window.open(
        `/api/admin/stock/${
          this.$route.params.id
        }/record/excel${encodeJsonToQuery(params)}`
      );
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  margin-bottom: 10px;
}
</style>
